export default {
  namespaced: true,
  state: {
    raceSeries: 'dtm',
    raceSeriesNavigation: 'headerNavigation',
    raceSeriesPartner: 'partners',
    raceSeriesManufacturer: 'manufacturers',
    raceSeriesDrivers: 'drivers',
    raceSeriesNews: 'news',
    raceSeriesNewsHighlights: 'newsHighlights',
    raceSeriesNewsCount: 'newsCount',
    raceSeriesHomeSlug: 'home2020',
    raceSeriesEventBanner: 'eventCountDown',
    raceSeriesFooter: 'footerNavigation',
    liveStatus: ''
  },
  getters: {
    raceSeries: state => {
      return state.raceSeries;
    },
    raceSeriesNavigation: state => {
      return state.raceSeriesNavigation;
    },
    raceSeriesPartner: state => {
      return state.raceSeriesPartner;
    },
    raceSeriesManufacturer: state => {
      return state.raceSeriesManufacturer;
    },
    raceSeriesDrivers: state => {
      return state.raceSeriesDrivers;
    },
    raceSeriesNews: state => {
      return state.raceSeriesNews;
    },
    raceSeriesNewsHighlights: state => {
      return state.raceSeriesNewsHighlights;
    },
    raceSeriesNewsCount: state => {
      return state.raceSeriesNewsCount;
    },
    raceSeriesHomeSlug: state => {
      return state.raceSeriesHomeSlug;
    },
    raceSeriesEventBanner: state => {
      return state.raceSeriesEventBanner;
    },
    raceSeriesFooter: state => {
      return state.raceSeriesFooter;
    },
    liveStatus: state => {
      return state.liveStatus;
    }
  },
  mutations: {
    SET_RACESERIES: (state, raceSeries) => {
      state.raceSeries = raceSeries.toLowerCase();
      state.raceSeriesNavigation = state.raceSeries === 'dtm' ? 'headerNavigation' : 'headerNavigationTrophy';
      state.raceSeriesPartner = state.raceSeries === 'dtm' ? 'partners' : 'partnersTrophy';
      state.raceSeriesManufacturer = state.raceSeries === 'dtm' ? 'manufacturers' : 'manufacturersTrophy';
      state.raceSeriesDrivers = state.raceSeries === 'dtm' ? 'drivers' : 'driversTrophy';
      state.raceSeriesNews = state.raceSeries === 'dtm' ? 'news' : 'newsTrophy';
      state.raceSeriesNewsHighlights = state.raceSeries === 'dtm' ? 'newsHighlights' : 'newsHighlightsTrophy';
      state.raceSeriesNewsCount = state.raceSeries === 'dtm' ? 'newsCount' : 'newsCountTrophy';
      state.raceSeriesHomeSlug = state.raceSeries === 'dtm' ? 'home2020' : 'homeTrophy';
      state.raceSeriesEventBanner = state.raceSeries === 'dtm' ? 'eventCountDown' : 'eventCountDownTrophy';
      state.raceSeriesFooter = state.raceSeries === 'dtm' ? 'footerNavigation' : 'footerNavigationTrophy';
    },
    SET_LIVESTATUS: (state, status) => {
      state.status = ['', 'live', 'prerace', 'afterrace'].includes(status) ? status : '';
    }
  }
};
